import { useEffect, useState } from "react";
import { getFeatureFlags } from "../../shared/featureFlagService";

/**
 * Custom hook to manage the waffle menu feature flag
 * @returns {boolean} isWaffleMenuEnabled - Whether the waffle menu is enabled
 */
export const useWaffleMenuFeatureFlag = (): boolean => {
    const [isWaffleMenuEnabled, setIsWaffleMenuEnabled] = useState(false);

    useEffect(() => {
        const fetchFeatureFlags = async (): Promise<unknown> => {
            return await getFeatureFlags("one-web-domain");
        };

        fetchFeatureFlags()
            .then((flags: unknown) => {
                if (
                    typeof flags === "object" &&
                    flags !== null &&
                    Object.prototype.hasOwnProperty.call(flags, "shouldShowWaffleMenu")
                ) {
                    setIsWaffleMenuEnabled(
                        (flags as { shouldShowWaffleMenu: boolean }).shouldShowWaffleMenu
                    );
                }
            })
            .catch((error: unknown) => {
                // eslint-disable-next-line no-console
                console.error("Failed to fetch feature flags:", error);
            });
    }, []);

    return isWaffleMenuEnabled;
};
